/**
 * Canonical dashboard params for list-performance-tags queries.
 * Every surface (stats tabs, prepared drops rows, drop creator) must send the
 * SAME range/currency/tz so the backend's per-campaign metrics cache records
 * are shared between them instead of duplicated per surface.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { ListPerformanceTagsParams } from '@/hooks';

import { reportingCurrency } from '@/lib/reporting-currency';

import { addDaysToIso, todayIsoDateParis } from './dateFormat';
import { toRangeISO } from '@/features/smswiser-campaigns/components/SmswiserCampaignStatsTab/shared/utils/display';

export const LIST_TAG_QUERY_TZ = 'Europe/Paris';


/** Last 30 days ending today (Paris), in the reporting currency (USD by default) — the stats tab's tag scope. */
export function buildListTagQueryParams(): ListPerformanceTagsParams {
  const to = todayIsoDateParis();
  const from = addDaysToIso(to, -30);
  const range = toRangeISO(from, to);
  return {
    from: range.from,
    to: range.to,
    tz: LIST_TAG_QUERY_TZ,
    currency: reportingCurrency(),
  };
}
